<template>
  <one-column-sidebar-left>
    <div slot="mainContent">
      <project-merge />
    </div>
  </one-column-sidebar-left>
</template>

<script>
import OneColumnSidebarLeft from "../layouts/OneColumnSidebarLeft.vue";
import ProjectMerge from "@/components/ProjectMerge.vue";
export default {
  name: "Projects",
  components: {
    ProjectMerge,
    OneColumnSidebarLeft  },
  data() {
    return {

    };
  },
}
</script>
